import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {

  isLoading = false;

  preferencesForm: FormGroup;
  isPreferencesFormSubmitted: boolean;

  isExtraFieldAdded = false;

  results: string[];

  constructor(private formBuilder: FormBuilder, private dashboardService: DashboardService, private activatedRoute: ActivatedRoute, private router: Router) {
    this.dashboardService.getRoadmapTabFlag().subscribe(data => {
      if (data === 'preferences') {
        // this.getStudentInfo();
        console.log('preferences');
      }
    });
  }

  ngOnInit() {
    this.preferencesForm = this.formBuilder.group({
      target_career: ['', Validators.required],
      backup_career: ['', Validators.required]
    });
  }

  // getters
  get target_career() { return this.preferencesForm.get('target_career'); }
  get backup_career() { return this.preferencesForm.get('backup_career'); }

  search(event) {
    console.log('de');
    // this.mylookupservice.getResults(event.query).then(data => {
    //   this.results = data;
    // });
  }

  anotherCareerField(action) {
    if (action === 'add') {
      this.preferencesForm.addControl('backup_career_2', this.formBuilder.control('', Validators.required));
      this.isExtraFieldAdded = true;
    }
    else if (action === 'remove') {
      this.preferencesForm.removeControl('backup_career_2');
      this.isExtraFieldAdded = false;
    }

    // get backup_career_2() { return this.preferencesForm.get('backup_career_2'); }
    // if (this.preferencesForm.contains('backup_career_2')) {
    // }
  }

  preferencesFromSubmit() {
    this.isPreferencesFormSubmitted = true;
    if (this.preferencesForm.invalid) {
      return;
    }

    console.log(this.preferencesForm.value);

  }

}
